<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormAddVehiclePlugin"
        :title="$t('labels.addVehiclePlugin')"
        :rules="rulesPluginRemooc"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-select
                    v-model="dataFormAddVehiclePlugin.type"
                    :label="$t('labels.vehicleModule.pluginType')"
                    required
                    :items="listPluginType"
                    key-id="key"
                    key-label="name"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-select-remooc
                    v-if="dataFormAddVehiclePlugin.type === PluginType.MOOC"
                    v-model="dataFormAddVehiclePlugin.pluginData"
                    v-model:name="dataFormAddVehiclePlugin.name"
                    :label="$t('labels.mooc')"
                    required
                    prop="pluginData"
                    @change="remoocChange" />
                <hts-form-input
                    v-else
                    v-model="dataFormAddVehiclePlugin.name"
                    :label="$t('labels.vehicleModule.pluginName')"
                    required
                    :color="props.color"
                    name="name"
                    prop="name" />

                <div>
                    <hts-form-select
                        v-model="dataFormAddVehiclePlugin.towingCapacity"
                        :label="$t('labels.vehicleModule.containerCapacity')"
                        :items="towedContainers"
                        key-id="value"
                        key-label="label"
                        :color="props.color"
                        multiple />
                </div>

                <hts-form-input
                    v-model="dataFormAddVehiclePlugin.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import { PluginType, ContainerTypes } from '../imports/form'

import SelectRemooc from '../autocomplete/select-remooc.vue'
import bank from '~/composables/api-url/partner/bank'
const store = $store()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const _initForm = {
  pluginData: '',
  name: '',
  type: 'MOOC',
  status: '',
  towingCapacity: [] as number[],
  description: ''
}

const emits = defineEmits(['close', 'refreshTables', 'reload'])
const dataFormAddVehiclePlugin = reactive({ ..._initForm })
const vehicleId = ref('')
const visible = ref(false)
const creating = ref(false)
const vehicle = ref<{ [key: string]: any }>({})
const configCont: { [key: string]: any } = ref({})

const openAddPlugin = (vehicleData: { [key: string]: any }) => {
  configCont.value = store.globalSettings.getGlobalSettings.configCont || {}
  vehicle.value = vehicleData
  vehicleId.value = vehicleData._id
  visible.value = true
}

defineExpose({
  openAddPlugin
})

const closeOverSide = () => {
  visible.value = false
  undo()
}

const listPluginType = [
  {
    key: PluginType.MOOC,
    name: $t('labels.supplyList.mooc')
  }
]

const handleSubmitFormAddVehiclePlugin = () => {
  const api = $url.vehicle.plugin.addPlugin
  creating.value = true
  $api(api, { body: { ...dataFormAddVehiclePlugin, vehicle: vehicleId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataFormAddVehiclePlugin, { ..._initForm })
        emits('refreshTables')
        process.client && $toast().success(resData.data)
        undo()
      }
      creating.value = false
      visible.value = false
    })
    .catch(() => {
      creating.value = false
    })
}

const containers = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

// loại cont lấy theo xe
const towedContainerVehicles = computed(() => {
  if (!remooc.value || !vehicle.value) {
    return []
  }

  // Tính toán trọng tải xe sau khi đã trừ trọng lượng của remooc
  const vehicleAvailableLoad = vehicle.value.vehicleLoad - remooc.value.weight || 0

  // Lọc các container phù hợp với trọng tải xe
  return containers.filter((item: { [key: string]: any }) => {
    const config = configCont.value[item.value]

    if (config) {
      // Tính tổng trọng lượng của container (Vỏ container + Hàng hóa)
      const containerTotalWeight = config.weightContainer + config.weightCargo

      // Kiểm tra nếu tổng trọng lượng container <= trọng tải còn lại của xe
      return containerTotalWeight <= vehicleAvailableLoad
    }
    // Nếu container không có cấu hình, loại bỏ nó
    return false
  })
})

// loại cont lấy theo remooc
const towedContainerRemoocs = ref<string[]>([])
const remooc = ref<{ [key: string]: any }>({})

const remoocChange = (val: any[]) => {
  if (!val || !val.length) {
    towedContainerRemoocs.value = []
    return
  }

  remooc.value = val[0]
  towedContainerRemoocs.value = val[0].towingCapacity || []

  const results = towedContainerVehicles.value.filter((item: any) => {
    if (towedContainerRemoocs.value.includes(String(item.value))) {
      return true
    }

    return false
  })

  dataFormAddVehiclePlugin.towingCapacity = results.map((item) => item.value)
}

const towedContainers = computed(() => {
  const results = towedContainerVehicles.value.filter((item: any) => {
    if (towedContainerRemoocs.value.includes(String(item.value))) {
      return true
    }

    return false
  })

  return results
})
const undo = () => {
  Object.assign(dataFormAddVehiclePlugin, { ..._initForm })
}

const rulesPluginRemooc = computed(() => {
  const result: { [key: string]: any } = {}
  if (dataFormAddVehiclePlugin.type) {
    result.pluginData = 'required'
  }
  return result
})
</script>
